const a = {
  "@ado/acs-standard-library": {
    "loading-bar": {
      "loading-message": () => "Getting everything ready!"
    },
    "contact-validator": {
      "duplicate-contact-message": () => "Contact already added",
      "maximum-recipients-message": () => "Maximum number of recipients reached for this invitation",
      "invalid-email-message": () => "Please enter a valid email address",
      "invalid-name-message": () => "You must enter a name"
    },
    "contact-list": {
      "name-label": () => "Name",
      "email-label": () => "Email"
    },
    "invitation-dialog": {
      "send-invite": () => "Send Invite"
    }
  }
};
export {
  a as default
};
//# sourceMappingURL=index.js.map
